<template>
  <div>
    <ProDialog
      ref="proDialogRef"
      :title="'预约出库'"
      :confirmButtonText="'确认预约'"
      :fields="fields"
      :formData.sync="appointForm"
      :rules="rules"
      :width="'500px'"
      :labelWidth="'110px'"
      :onConfirm="handleConfirm"
    >
      <template slot="buyerId" slot-scope="{ field }">
        <div style="display: flex; align-items: center; gap: 10px">
          <!-- 手动渲染el-select，完全可控 -->
          <el-select
            v-model="appointForm.buyerId"
            :placeholder="field.props.placeholder"
            :disabled="field.isView || !field.editable"
            style="flex: 1; width: 100%"
          >
            <el-option
              v-for="option in buyersList"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>

          <!-- 新增按钮 -->
          <el-button type="primary" size="small" @click="showAddBuyerModal"
            >新增</el-button
          >
        </div>
      </template>
      <template slot="amount" slot-scope="{ name, field, value, updateValue }">
        <el-input-number
          v-model="appointForm.amount"
          :placeholder="field.props.placeholder"
          :min="0"
          :max="maxAmount"
          :step="1"
        />
        <div style="font-size: 12px; color: #999; margin-top: 5px">
          本次最多可出库 {{ maxAmount }}KG，其余仓库{{
            pledgedAmount
          }}KG质押中， {{ outgoingAmount }}KG出库中
        </div>
      </template>
    </ProDialog>
    <!-- 新增买粮人弹窗 -->
    <AddBuyerModal
      ref="addBuyerModal"
      @confirm="handleAddBuyerConfirm"
    ></AddBuyerModal>
  </div>
</template>

<script>
import { getBuyersList, reserveOutbound } from "@/api/warehousingService";
import AddBuyerModal from "./AddBuyerModal.vue";
import ProDialog from "@/components/dialog/ProDialog.vue";

export default {
  name: "AppointOutWarehouseModal",
  components: {
    AddBuyerModal,
    ProDialog,
  },
  props: {
    receiptInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      buyersList: [],
      appointForm: {
        grainType: "",
        grainLevel: "",
        warehouseCompany: "",
        outboundTime: "",
        amount: "",
        buyerId: "",
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7;
        },
        // selectableRange: '00:00:00 - 23:59:59',
      },
      rules: {
        outboundTime: [
          { required: true, message: "请选择出库时间", trigger: "change" },
        ],
        amount: [
          { required: true, message: "请输入出库数量", trigger: "blur" },
          {
            type: "number",
            min: 0,
            message: "出库数量必须大于0",
            trigger: "blur",
          },
        ],
        buyerId: [
          { required: true, message: "请选择或新增买粮方", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    maxAmount() {
      return this.receiptInfo?.balanceWeight || 0;
    },
    pledgedAmount() {
      return this.receiptInfo?.pledgeWeight || 0;
    },
    outgoingAmount() {
      return this.receiptInfo?.dispatchingWeight || 0;
    },
    fields() {
      return [
        {
          prop: "grainType",
          label: "粮食品种",
          type: "input",
          editable: false,
        },
        {
          prop: "grainLevel",
          label: "粮食级别",
          type: "input",
          editable: false,
        },
        {
          prop: "warehouseCompany",
          label: "仓储公司",
          type: "input",
          editable: false,
        },
        {
          prop: "outboundTime",
          label: "出库时间",
          type: "date",
          editable: true,
          props: {
            placeholder: "选择日期时间",
            type: "datetime",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            pickerOptions: this.pickerOptions,
          },
        },
        {
          prop: "amount",
          label: "出库数量(KG)",
          type: "number",
          editable: true,
          props: {
            placeholder: "请输入出库数量",
            min: 0,
            step: 1,
          },
        },
        {
          prop: "buyerId",
          label: "买粮方",
          type: "select",
          required: true,
          editable: true,
          props: {
            placeholder: "请选择买粮人",
            options: this.buyersList,
          },
        },
      ];
    },
  },
  methods: {
    initForm() {
      this.appointForm = {
        grainType: this.receiptInfo.grainCategoryName || "",
        grainLevel: this.receiptInfo.grainCategoryLevel || "",
        warehouseCompany: this.receiptInfo.companyName || "",
        outboundTime: "",
        amount: "",
        buyerId: "",
      };
    },

    async fetchBuyersList() {
      try {
        const res = await getBuyersList();
        console.log(res, "买两人列表");
        if (res.data && Array.isArray(res.data)) {
          this.buyersList = res.data.map((buyer) => ({
            label: buyer.name,
            value: buyer.id,
          }));
        }
      } catch (error) {
        this.$message.error("获取买粮人列表失败");
        console.error("获取买粮人列表失败", error);
      }
    },

    showAddBuyerModal() {
      this.$refs.addBuyerModal.handleOpen();
    },

    handleAddBuyerConfirm(newBuyer) {
      // 添加新的买粮人到列表
      this.fetchBuyersList();
      // 选中新添加的买粮人
      console.log("新买粮人", newBuyer);
      this.appointForm.buyerId = newBuyer?.id;
    },

    async handleConfirm() {
      // 检查出库数量是否超过最大值
      if (parseFloat(this.appointForm.amount) > this.maxAmount) {
        this.$message.error(`出库数量不能超过${this.maxAmount}吨`);
        return;
      }

      try {
        const data = {
          stockInOrderId: this.receiptInfo.id,
          appointmentDispatchWeight: parseFloat(this.appointForm.amount),
          appointmentDispatchTime: this.appointForm.outboundTime,
          grainBuyerId: this.appointForm.buyerId,
        };

        const res = await reserveOutbound(data);
        console.log(res, "预约出库结果");
        if (res.code == 0) {
          this.$message.success("预约成功");
          this.$emit("confirm");
          this.handleClose();
        } else {
          this.$message.error(res.msg || "预约失败");
        }
      } catch (error) {
        this.$message.error("预约失败");
        console.error("预约出库失败", error);
      }
    },

    handleOpen() {
      // 每次打开弹窗前都执行初始化表单和获取买粮人操作
      if (this.receiptInfo) {
        this.initForm();
        this.fetchBuyersList();
      }
      this.$refs.proDialogRef.handleOpen();
    },

    handleClose() {
      this.$refs.proDialogRef.handleClose();
    },
  },
};
</script>

<style scoped lang="less">
/* 可以根据需要添加样式 */
</style>
